function ModeToolModeList({
  modeOptions,
  selectedMode,
  modePointCount,
  onSelectMode,
  onStopWalkingRouteShapeEdit,
  isBatchAudioBusy = false,
}) {
  // Business rule: mode tool works with one tour_type at a time.
  // When backend returns a single mode (even as array), selector is hidden.
  if (!Array.isArray(modeOptions) || modeOptions.length <= 1) return null;

  return (
    <div className="mode-route-tool-list">
      {(modeOptions || []).map((mode) => {
        const modeType = mode.value;
        const count = Number(modePointCount?.[modeType] || 0);
        return (
          <button
            key={modeType}
            type="button"
            className={`mode-route-tool-item ${selectedMode === modeType ? "active" : ""}`}
            disabled={isBatchAudioBusy}
            onClick={(event) => {
              event.stopPropagation();
              onStopWalkingRouteShapeEdit?.();
              onSelectMode?.(modeType);
            }}
          >
            <span>{mode.label}</span>
            <small>{count} points</small>
          </button>
        );
      })}
    </div>
  );
}

export default ModeToolModeList;
